import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import {useTheme} from '@mui/material/styles'
import Logo from 'src/images/logo.png'
import {Stack, IconButton} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CuiAvatar from '../custom/CuiAvatar'
import {observer} from 'mobx-react-lite'
import {useMainStore} from 'src/contexts/Main'
import useResponsive from 'src/hooks/useResponsive'

// ----------------------------------------------------------------------

type HeaderProps = {
  onOpenNav?: () => void
}

const Header = ({onOpenNav}: HeaderProps) => {
  const {
    loginStore: {currentUser}
  } = useMainStore()
  const theme = useTheme()
  const isDesktop = useResponsive('up', 'lg')

  return (
    <AppBar
      sx={{
        position: 'static',
        boxShadow: '0 8px 32px 0 rgba(77, 0, 38, 0.24)',
        background:
          'linear-gradient(135deg, #2E0017 0%, #4d0026 50%, #800040 100%)',
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter
        }),
        height: '80px',
        overflow: 'visible'
      }}
    >
      <Toolbar
        sx={{
          px: {lg: 5},
          p: 0,
          minHeight: '80px !important',
          height: '100%',
          overflow: 'visible'
        }}
      >
        <Stack
          direction="row"
          width="100%"
          alignItems="center"
          position="relative"
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{zIndex: 1}}
          >
            {!isDesktop && onOpenNav && (
              <IconButton
                data-testid="menu-button"
                onClick={onOpenNav}
                sx={{
                  mr: 1,
                  color: 'inherit'
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {currentUser && (
              <CuiAvatar
                name={currentUser?.fullName}
                value={currentUser?.initials}
                color={'white'}
              />
            )}
          </Stack>
          <Stack
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none'
            }}
          >
            <img
              src={Logo}
              alt="logo"
              style={{
                height: 90,
                objectFit: 'contain'
              }}
            />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

Header.propTypes = {
  onOpenNav: PropTypes.func
}

export default observer(Header)
